import * as React from 'react';
import * as styles from './styles.css';
import { Suggest } from './components';
import { ILocation } from '../../../../../types/location';
import { LocationSearchField } from '../LocationSearchField';

export interface ILocationSuggestFieldProps {
  inputValue: string;
  suggest: ILocation[];
  isSuggestShown: boolean;
  placeholder: string;
  isLoading: boolean;

  onChange(value: string): void;

  onItemClick(value: ILocation): void;
}

export const LocationSuggestField = React.forwardRef<HTMLDivElement, ILocationSuggestFieldProps>(
  ({ onChange, inputValue, suggest, onItemClick, isSuggestShown, placeholder, isLoading }, ref) => {
    return (
      <div ref={ref} className={styles['container']} data-testid="location-suggest">
        <div className={styles['input-container']}>
          <LocationSearchField isLoading={isLoading} placeholder={placeholder} value={inputValue} onChange={onChange} />
        </div>
        {isSuggestShown && <Suggest suggest={suggest} onItemClick={onItemClick} />}
      </div>
    );
  },
);

LocationSuggestField.displayName = 'LocationSuggestField';
